import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSelector } from '../../../table/state/selector'
import {
    TABLE_CHECK_IN,
    TABLE_ESCALATION,
    TABLE_IN_SHOP_SCAN,
    TABLE_REFINEMENT_PRODUCTION,
    TABLE_REFINEMENT_SET,
    TABLE_REFINEMENT_BOOKING,
    TABLE_REFINEMENT_SHOP,
    TABLE_RETAINER,
    TABLE_RETAINER_REFINEMENT,
    TABLE_SET,
    TABLE_SHOP_SCAN,
    TABLE_TREATMENT,
    TABLE_IMPLANT_3DSCAN,
    TABLE_IMPLANT_PLAN,
    TABLE_IMPLANT_TREATMENT,
    TABLE_END_OF_TREATMENT,
} from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}


export const selectSetTable = createTableSelector(selectOwnState, TABLE_SET)

export const selectCheckInTable = createTableSelector(selectOwnState, TABLE_CHECK_IN)

export const selectInShopScanTable = createTableSelector(selectOwnState, TABLE_IN_SHOP_SCAN)

export const selectImplant3dScanTable = createTableSelector(selectOwnState, TABLE_IMPLANT_3DSCAN)

export const selectImplantPlanTable = createTableSelector(selectOwnState, TABLE_IMPLANT_PLAN)

export const selectImplantTreatmentTable = createTableSelector(selectOwnState, TABLE_IMPLANT_TREATMENT)

export const selectShopScanTable = createTableSelector(selectOwnState, TABLE_SHOP_SCAN)

export const selectTreatmentTable = createTableSelector(selectOwnState, TABLE_TREATMENT)

export const selectRefinementProductionTable = createTableSelector(selectOwnState, TABLE_REFINEMENT_PRODUCTION)

export const selectRefinementBookingTable = createTableSelector(selectOwnState, TABLE_REFINEMENT_BOOKING)

export const selectRefinementShopTable = createTableSelector(selectOwnState, TABLE_REFINEMENT_SHOP)

export const selectRefinementSetTable = createTableSelector(selectOwnState, TABLE_REFINEMENT_SET)

export const selectRetainerTable = createTableSelector(selectOwnState, TABLE_RETAINER)

export const selectRetainerRefinementTable = createTableSelector(selectOwnState, TABLE_RETAINER_REFINEMENT)

export const selectEscalationTable = createTableSelector(selectOwnState, TABLE_ESCALATION)

export const selectEndOfTreatmentTable = createTableSelector(selectOwnState, TABLE_END_OF_TREATMENT)





// WEBPACK FOOTER //
// ./src/modules/sales-order/state/search/selector.js